var map = {
	"./bg-1.png": "KZKs",
	"./bg-2.png": "kk9U",
	"./bg-3.png": "sJp6",
	"./bg-4.png": "uc3n",
	"./bg-5.png": "CSHP"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "SbZ0";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pcgaofu/bnaner ^\.\/bg\-.*\.png$
// module id = SbZ0
// module chunks = 0